module.exports = __webpack_public_path__ + "img/title-3.9ea4445b.png";